module.exports = __webpack_public_path__ + "img/btn_back.fe580252.png";